import {
  ManageableProduct,
  ProductType,
} from '@airship-platform/airship-proposal';
import { PlusIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useProductNavigationActions } from '../../proposal-option-items';

interface AddProductsButtonProps {
  groupingName: ManageableProduct['groupingName'];
  variant?: 'button' | 'iconButton';
}

interface ButtonConfig {
  label: string;
  productTypes: ProductType[];
  productPageTitle: string;
  replacePageTitle: string;
}

export const BUTTON_CONFIG: Record<
  ManageableProduct['groupingName'],
  ButtonConfig
> = {
  SYSTEM: {
    label: 'Add more',
    productTypes: ['EQUIPMENT', 'SERVICE'],
    productPageTitle: 'Add Services / Equipment',
    replacePageTitle: 'Replace Services / Equipment',
  },
  ADDONS: {
    label: 'Add more',
    productTypes: ['MATERIAL'],
    productPageTitle: 'Add materials, accessories, services',
    replacePageTitle: 'Replace materials, accessories, services',
  },
  UPGRADES: {
    label: 'Add upgrades',
    productTypes: [],
    productPageTitle: 'Add Upgrades',
    replacePageTitle: 'Replace Upgrades',
  },
};

const AddProductsButton: React.FC<AddProductsButtonProps> = ({
  groupingName,
  variant = 'button',
}) => {
  const { navigateToQueryProducts, isReadOnly } = useProductNavigationActions();
  const config = BUTTON_CONFIG[groupingName];

  const handleClick = () =>
    navigateToQueryProducts({
      productTypes: config.productTypes,
      groupingName,
      productPageTitle: config.productPageTitle,
    });

  if (variant === 'iconButton') {
    return (
      <IconButton
        color="gold"
        size="small"
        disabled={isReadOnly}
        onClick={handleClick}
      >
        <PlusIcon />
      </IconButton>
    );
  }

  return (
    <Button
      color="softGold"
      endIcon={<PlusIcon />}
      disabled={isReadOnly}
      onClick={handleClick}
    >
      {config.label}
    </Button>
  );
};

export default AddProductsButton;
